module.exports = __webpack_public_path__ + "img/banner2.77898d74.png";